
  // Export
  module.exports =
  {
    report:
    {
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#submissions'), APPLICATION._PATH_PREFIX + 'service-summary/report-data', 'ServiceSummary', 'reportData')
      }
    },
    reportData:
      {
        _init: function ()
        {
          APPLICATION._APPLICATION.processLinks('#submissions', 'ServiceSummary', 'reportData')
        }
      }
  }